import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';

export default function BatteryExpandability() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.BatteryExpandability');
    return (
        <div className={`${styles.batteryExpandability}`}>
            <div className="solution-item">
                <div className="text-box">
                    <h2>
                        <span className="sub-title">{t('label')}&nbsp;</span>
                        <span className="title">{t('title')}</span>
                    </h2>
                    <div className="desc">{t('desc')}</div>
                </div>

                <div className="video-box">
                    <video
                        src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718771485154/sf.mp4"
                        muted
                        playsInline
                        autoPlay
                        loop
                        preload="auto"
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
